import { Container } from '@mui/material';
import UnseenSection from './see_the-unseen_section_component';
import { TenantManagementOnLandingPage } from './tenant_Management_on_main_landing_page.component';
import { AllModulesOnLandingPage } from './all_modules_on_landing_page.component';

export const SideBox = () => {
  return (
    <Container sx={{ marginTop: '1%' }}>
      <UnseenSection />
      <TenantManagementOnLandingPage />
      <AllModulesOnLandingPage />
    </Container>
  );
};
